import React from "react";
import MonoBar from "./../GraphViews/MonoBar";
import { updateRankElements } from "./../../utils";
import StatsUtils from "../../../../utils/stats";
import Spinner from "../Spinner";

const MonoBarView = props => {
	const data = props.data || {};
	let topScores = { first: -Infinity, last: Infinity, second: -Infinity };
	const nbElements = Object.keys(data).length;
	const dicColors = {
		AUCHAN: "#983838",
		"AUCHAN SUPERMARCHE": "#F25353",
		CARREFOUR: "#3872C8",
		"CARREFOUR MARKET": "#6EB1FA",
		CORA: "#224392",
		"GEANT CASINO": "#92D54D",
		INTERMARCHE: "#000000",
		LECLERC: "#E7853A",
		U: "#52D2DA",
	};
	const values = Object.keys(data)
		.sort((a, b) => (a > b ? 1 : -1))
		.map(element => {
			data[element] = data[element] || {};
			const indicator = StatsUtils.roundKpiValue(props.kpi, data[element].indicator || 0);
			updateRankElements(indicator, topScores, nbElements);
			return indicator;
		});
	const colors = Object.keys(data)
		.sort((a, b) => (a > b ? 1 : -1))
		.map(element => {
			return dicColors[element];
		});
	const labels = Object.keys(data)
		.sort((a, b) => (a > b ? 1 : -1))
		.map(element => {
			const elementData = data[element].data || [];
			const valuesArray = elementData.map(data => {
				if (props.kpi && props.kpi.format === "Pourcentage"|| props.kpi.format_input === "percentage")
					return Number(
						StatsUtils.formatKpiValue(props.kpi, data.v).slice(0, -1)
					);
				return Number(
					StatsUtils.formatKpiValue(props.kpi, data.v)
						.replace(/\s/g, "")
						.replace(/\€/g, "")
				);
			});
			const newestPercentage =
				valuesArray.length > 0 ? valuesArray[valuesArray.length - 1] : 0;

			return newestPercentage === topScores.first ||
				newestPercentage === topScores.second ||
				newestPercentage === topScores.third
				? `★@${element}`
				: element;
		});

	const datasets = [
		{
			data: values,
			backgroundColor: colors,
			borderColor: colors,
			borderWidth: 1,
		},
	];
	const dataBar = { labels, datasets };
	return (
		<React.Fragment>
			<h2 className="p-page-subtitle p-txt-center">{props.title}</h2>
			<div
				style={{
					height: "90%",
					width: "100%",
					position: "relative",
					margin: "auto",
				}}
			>
				{props.loading ? (
					<Spinner />
				) : (
					<MonoBar data={dataBar} />
				)}
			</div>
		</React.Fragment>
	);
};

export default MonoBarView;



// WEBPACK FOOTER //
// src/modules/stats/components/DashboardViews/MonoBarView.js